import { useFlags } from "launchdarkly-react-client-sdk";
import React from "react";

import { Headline } from "@fronterahealth/frontera-ui-components";

import { useProviderIntegrationsQuery } from "@api/graphql/types-and-hooks";
import { ZoomIntegration } from "@pages/Integrations/Components/ZoomIntegration";

export const UserIntegrationsPage: React.FC = () => {
  const { data: integrationsData, refetch: refetchIntegrations } = useProviderIntegrationsQuery();
  const flags = useFlags();

  return (
    <div>
      <Headline size="medium">Manage Integrations</Headline>
      <br />
      {flags["zoom-integration"] ? (
        <ZoomIntegration
          zoomIntegrationData={integrationsData?.providerIntegrations?.zoomIntegration}
          onIntegrationComplete={async () => {
            await refetchIntegrations();
          }}
        />
      ) : null}
    </div>
  );
};
